import React from 'react';
import member1 from '../assets/images/team/وحید غفاری.jpg';
import member2 from '../assets/images/team/امیر رضایی.jpeg';
import member3 from '../assets/images/team/مهدی محمدی.jpeg';
import member4 from '../assets/images/team/نفیسه باقری.jpeg';
import member5 from '../assets/images/team/مونا عبدی.jpeg';
import member6 from '../assets/images/team/علی غفاری.jpg';
import member7 from '../assets/images/team/مهدی فهرستی.jpeg';
import member8 from '../assets/images/team/وحید کریمی.jpeg';
import member9 from '../assets/images/team/مهدی ذالی.jpeg';


export const Teams10DataSource = {
  wrapper: { className: 'home-page-wrapper teams1-wrapper' },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '',always:false },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>خانواده ما</p>
          </span>
        ),
      },
      {
        name: 'content~kid9jcfav9',
        className: '',
        children: (
          <span>
            <p>
              ما در مدتاک یاد گرفتیم با هم زندگی کنیم، ‌مثل یک خانواده که در
              سختی‌ها و دشواری‌ها هوای همدیگر را دارند؛ و به هم کمک می‌کنیم که
              هیچ چالشی نتواند ما را از مسیر اصلی دور کند و به این خانواده آسیبی
              وارد کند. با تمام توان تلاش می‌کنیم که بتوانیم بهترین شرکت ارائه
              دهنده خدمات پرداخت باشیم.
            </p>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children: member1,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                      <p>وحید غفاری</p>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                  <p>هم بنیان گذار و مدیرعامل</p>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:member2,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                    <p>امیر رضایی</p>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                  <p>هم بنیان گذار و مدیر فنی</p>
              ),
            },
          ],
        },
      },
      {
        name: 'block~kidadbth1do',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:member6,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <span>
                    <p>علی غفاری</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>مدیر فروش</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~kidadaqfrnf',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:member4,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <span>
                    <p>نفیسه باقری</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>طراح و گرافیست</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~kidad9zp2i6',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children: member5,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <span>
                    <p>مونا عبدی</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>پشتیبانی و امور مشتریان</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~kidad8plt9n',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children: member3,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                    <p>مهدی محمدی</p>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                  <p>توسعه دهنده سمت سرور</p>
              ),
            },
          ],
        },
      },
      {
        name: 'block~kidadbth1do',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:member7,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <span>
                    <p>مهدی فهرستی</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>توسعه دهنده سمت موبایل</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~kidadbth1do',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:member8,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <span>
                    <p>وحید کریمی</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>توسعه دهنده سمت وب</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~kidadbth1do',
        className: 'block',
        md: 8,
        xs: 24,
        titleWrapper: {
          children: [
            {
              name: 'image',
              className: 'teams1-image',
              children:member9,
            },
            {
              name: 'title',
              className: 'teams1-title',
              children: (
                <span>
                  <span>
                    <p>مهدی زالی</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              className: 'teams1-job',
              children: (
                <span>
                  <p>پشتیبانی فنی</p>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
